
const programDrillType = {
  EXERCISE: 1,
  START_SUPERSET: 2,
  END_SUPERSET: 3,
  START_CIRCUIT: 4,
  END_CIRCUIT: 5
} as const;

export type ProgramDrillType = keyof typeof programDrillType;
export default programDrillType;